<div
  [ngClass]="{ 'select-dropdown--expanded': expanded() }"
  [ngStyle]="{ position: isRelative() ? 'relative' : 'absolute' }"
  class="select-dropdown"
>
  <ul class="select-dropdown__list">
    @if (options()?.length === 0 && noResultsLabel()) {
      <li class="select-dropdown__list-item">
        <p class="select-dropdown__no-results">{{ noResultsLabel() }}</p>
      </li>
    }

    @for (option of options(); track $index; let i = $index) {
      <li class="select-dropdown__list-item">
        <app-form-select-option
          #option
          (clicked)="onOptionSelection($event)"
          [disabled]="disabled()"
          [focused]="(focusedOption$ | async)?.option()?.value === option.value"
          [option]="option"
          [optionSubLabel]="optionSubLabels() ? optionSubLabels()?.[i] : ''"
          [optionTemplate]="optionTemplate()"
          [searchTerm]="searchTerm()"
          [selected]="
            selectedValue() === option.value ||
            selectedValues()?.includes(option.value)
          "
        />
      </li>
    }
  </ul>
</div>
